import { AlertaSimplesErro } from './MensagemHelper';

export default class PdfHelper {
  static baixarPdf(data, nomeArquivo) {
    try {
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = nomeArquivo;
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      AlertaSimplesErro('Erro ao gerar o PDF para download:', error);
    }
  }
}
